import { COMPONENT_EXTENDER } from 'extender'

const SingleContainerLayout = COMPONENT_EXTENDER('components/layouts/SingleContainerLayout')
const DynamicFormComponent = COMPONENT_EXTENDER('components/core/ApplicationForms/DynamicForm/DynamicForm-component')

const DynamicFormPage = () => (
    <SingleContainerLayout>
        <DynamicFormComponent />
    </SingleContainerLayout>
)

export default DynamicFormPage
